export default "__VITE_ASSET__LBBa85wh__"